import { nonNullable } from '@siteless/util';
import { useMemo } from 'react';
import avatars from '../config/avatars';
import BallotsCompletedResource from '../resources/Ballot/Completed';
import AllUserProfilesResource from '../resources/AllUserProfiles';
import OneLeagueResource from '../resources/League/One';
import { IncompleteAvatarGrid } from './IncompleteAvatarGrid';
import withSuspense from './withSuspense';
import { usePresentationMode } from '../util/usePresentationMode';
import { ClusterBallotTier } from './ClusterBallotTier';
import useCopy from '../util/useCopy';

export let LeagueIncompleteBallotTier = withSuspense(
  ({ leagueId }: { leagueId: string }) => {
    let [presentationMode] = usePresentationMode();
    let copy = useCopy();
    let league = OneLeagueResource.use(leagueId);
    let completedMap = BallotsCompletedResource.use();
    let allEnums = AllUserProfilesResource.use();
    let userBallots = useMemo(
      () =>
        (league?.memberUserIds || [])
          .filter((userId) => !completedMap[userId])
          .map((userId) => {
            let user = allEnums.users[userId];
            if (!user) return null;

            return {
              key: userId,
              score: 0,
              ArtworkComponent:
                avatars[user.avatarId || 'AVATAR_0'].ArtworkComponent,
              handle: user.handle,
              avatarBackgroundHex: user.avatarBackgroundHex,
            };
          })
          .filter(nonNullable),
      [league, allEnums, completedMap],
    );

    if (!userBallots.length) return null;

    if (presentationMode)
      return <ClusterBallotTier incompleteTier userBallots={userBallots} />;

    return (
      <div className="flex flex-col pb-4">
        <div className="bg-neutral-0 sticky top-1 z-20 flex items-center justify-center self-center rounded-full border-4 border-neutral-100 px-3 py-1 text-sm font-medium text-purple-900 shadow-lg">
          {copy['Incomplete Ballots 🥲']}
        </div>
        <IncompleteAvatarGrid users={userBallots} />
      </div>
    );
  },
);
